import React from 'react';
import { RxCross2 } from 'react-icons/rx';

export type LinkModalProps = {
    url: string;
    isOpen: boolean;
    closeModal: () => void;
    onChangeUrl: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onSaveLink: (e: React.MouseEvent<HTMLButtonElement>) => void;
    onRemoveLink: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

export function LinkModal(props: LinkModalProps) {
    const {
        url,
        closeModal,
        onChangeUrl,
        onSaveLink,
        onRemoveLink,
        isOpen,
        ...rest
    } = props;
    return (
        <div
            {...rest}
            isOpen={isOpen}
            className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75'
            onClick={closeModal}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className='relative w-full max-w-md rounded-lg bg-white shadow-lg'
            >
                <button
                    type='button'
                    className='text-gray-600 hover:text-gray-900 absolute right-4 top-4 text-lg'
                    onClick={closeModal}
                >
                    <RxCross2 />
                </button>
                <div className='p-8'>
                    <h2 className='mb-[30px] text-[22px] font-bold'>
                        Edit link
                    </h2>
                    <input
                        className='border-gray-300 mb-5 mt-1 w-full rounded-md border px-3 py-2 text-xs outline-none focus:border-primary'
                        autoFocus
                        value={url}
                        onChange={onChangeUrl}
                    />
                    <div className='modal-buttons'>
                        <button
                            className='rounded-full bg-danger px-[24px] py-[7px] text-[14px]/[18px] font-semibold uppercase text-black transition-colors duration-500 hover:bg-red'
                            type='button'
                            onClick={onRemoveLink}
                        >
                            Remove
                        </button>
                        <button
                            className='rounded-full bg-warning px-[24px] py-[7px] text-[14px]/[18px] font-semibold uppercase text-black transition-colors duration-500 hover:bg-yellow '
                            type='button'
                            onClick={onSaveLink}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
